import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './home';
import ArtistProfile from './team/artist-profile';
import OurWork from './our-work';
import OurHistory from './our-history';
import Team from './team';
import Contact from './contact';
import ShopTour from './shop-tour';

class MainLayout extends React.Component {
  render() {
    return (
      <main>
        <Switch>
          <Route path='/' exact component={ Home }/>
          <Route path="/team/:artistSlug" component={ ArtistProfile } />
          <Route path="/our-work" render={ ()=><OurWork pagetitle="our work" /> }/>
          <Route path="/our-history" render={ ()=><OurHistory pagetitle="our history" /> }/>
          <Route path="/shop-tour" render={ ()=><ShopTour pagetitle="shop tour" /> }/>
          <Route path="/team" render={ ()=><Team pagetitle="our team" /> }/>
          <Route path="/contact" render={ ()=><Contact pagetitle="contact" /> }/>
        </Switch>
      </main>
    );
  }
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/routes/index.js